import moment from 'moment-timezone'
import { sows, plans as usersPlan } from '@abroad/components'
import labels from '../constants/labels'

export const isLGScreen = window.innerWidth > 1080 ? true : false
export const isSMScreen =
  window.innerWidth > 576 && window.innerWidth < 768 ? true : false
export const isMDScreen =
  window.innerWidth > 768 && window.innerWidth < 1080 ? true : false

export const getQuarter = (quater) => {
  if (quater === 1) {
    return 'JAN - MARCH'
  } else if (quater === 2) {
    return 'APRIL - JUNE'
  } else if (quater === 3) {
    return 'JULY - SEPTEMBER'
  } else {
    return 'OCTOBER - DECEMBER'
  }
}

export const isDatesOverlap = (rangeOne, rangeTwo) => {
  if (
    moment(rangeTwo.startDate).isBetween(
      rangeOne.startDate,
      rangeOne.endDate,
    ) ||
    moment(rangeTwo.endDate).isBetween(rangeOne.startDate, rangeOne.endDate) ||
    moment(rangeOne.startDate).isBetween(
      rangeTwo.startDate,
      rangeTwo.endDate,
    ) ||
    moment(rangeOne.endDate).isBetween(rangeTwo.startDate, rangeTwo.endDate) ||
    moment(rangeTwo.startDate).isSame(rangeOne.startDate) ||
    moment(rangeTwo.endDate).isSame(rangeOne.endDate) ||
    moment(rangeTwo.startDate).isSame(rangeOne.endDate) ||
    moment(rangeTwo.endDate).isSame(rangeOne.startDate)
  ) {
    return true
  }
  return false
}

export const prevMonthFirstDay = moment().subtract(1, 'months').startOf('month')

export const prevMonthLastDay = moment().subtract(1, 'months').endOf('month')

export const getDateRangeString = (startDate, endDate) => {
  return `${moment(startDate).format('MM/DD/YYYY')} - ${moment(endDate)
    .subtract(1, 'days')
    .format('MM/DD/YYYY')}`
}

export const getFileName = (organizationCode, startDate, endDate) => {
  return `${organizationCode}_cyclestart_from_${moment(startDate).format(
    'MM-DD-YYYY',
  )}_to_${moment(endDate).subtract(1, 'days').format('MM-DD-YYYY')}.xlsx`
}

export const getNameArrayFromCompanies = (data) => {
  return data.map((e) => e.name)
}

export const roleList = {
  ic: 'Employee (Individual Contributor/Team Member, Student)',
  manager: 'First-Line Manager (Direct Manager of Individual Contributors)',
  leader: 'Middle Manager (Department Heads, Manager of First-Line Managers)',
  executive:
    'Top-Level Manager (Business Unit Leads, Executives/C-Suite, Partners)',
  ceo: 'CEO / FOUNDER / Board of Directors',
  none: 'No Titles or Hierarchy',
}

export const participantLevelsForGroup = {
  leader: 'Leader',
  executive: 'Executive',
  ceo: 'CEO or Board Member',
  ic: 'Individual Contributor',
  manager: 'Manager',
}

export const getGroupLabel = (value) => {
  let label
  switch (value) {
    case 1:
      label = 'Organization'
      break
    case 2:
      label = 'Network'
      break
    case 3:
      label = 'Promo Code'
      break
    case 4:
      label = 'Free Select'
      break
    case 5:
      label = 'Organization With SOW'
      break
    case 6:
      label = 'Network With SOW'
      break
    default:
      break
  }
  return label
}

export const plans = {
  [usersPlan.free.code]: usersPlan.free.name,
  [usersPlan.growth.code]: usersPlan.growth.name,
  [usersPlan.coaching.code]: usersPlan.coaching.name,
}

export const emailRegex =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const columnNameForPL = [
  'IC',
  'Manager',
  'Leader',
  'Executive',
  'Board & CEO',
]

export const getMomentConvertedDateForSOW = (date) =>
  moment(date).format('MM/DD/YY')

export const removeEmpty = (values) => {
  return Object.fromEntries(
    Object.entries(values).filter(([_, v]) => v != null && v !== ''),
  )
}

export const getUnmaskedObject = (obj, unmaskFunction) =>
  Object.entries(obj).reduce(
    (prev, [key, value]) => ({
      ...prev,
      [key]:
        typeof value === 'string' && value !== ''
          ? unmaskFunction(value)
          : value,
    }),
    {},
  )
export const isSOWGroups = (groupType) => {
  return (
    groupType === labels.allGroupType.COMPANY_WITH_SOW ||
    groupType === labels.allGroupType.NETWORK_WITH_SOW
  )
}

export const getManageGroupURL = (teamData, isadmin = false) => {
  const sowGroups = isSOWGroups(teamData?.groupType)
  const groupId = teamData?.groupId
  if (sowGroups && isadmin) {
    return `/admin/${
      teamData?.groupType === labels.allGroupType.COMPANY_WITH_SOW
        ? 'organization'
        : 'network'
    }/${groupId?.name}/sow/${teamData?.b2bSOWId}/sow-group/${teamData?._id}`
  }
  return `/admin/groups/${teamData?._id}/information`
}

export const getLoginUserCoachingPlan = (data, userId) => {
  const planType = sows.planType

  // individual plan
  const individualPlanData = data?.filter(
    (plan) => plan?.type === planType.individual && plan?.isCoachOfCurrentPlan, // type && isCoachOfCurrentPlan key
  )

  const updateIndividualPlans = individualPlanData.map((e) => ({
    label: e.planName,
    value: e._id,
    type: sows.planType.individual,
    sessionDuration: e.sessionDuration,
    sowStatus: e.sowStatus,
    remainingSession: e.remainingSession,
    terminatedOn: e.terminatedOn,
  }))

  // B2B plan
  const b2bPlanData = data?.filter((plan) => plan?.type === planType.b2b) // type key

  const filterB2BPlans = b2bPlanData?.filter((plan) =>
    plan?.coaches?.map((coach) => coach?.coachId?._id).includes(userId),
  )

  const updateB2BPlans = filterB2BPlans.map((e) => ({
    label: e.planName,
    value: e._id,
    type: sows.planType.b2b,
    sessionDuration: e.sessionDuration,
  }))
  const labelValuesData = [...updateIndividualPlans, ...updateB2BPlans]
  const coachingPlanData = [...individualPlanData, ...b2bPlanData]
  return { labelValuesData, coachingPlanData }
}

export const sortByGivenKey = (array, key) => {
  return array.sort((a, b) => {
    if (a[key] < b[key]) return -1
    if (a[key] > b[key]) return 1
    return 0
  })
}

export const checkEnteredTeamExist = (teams, enteredTeam) => {
  const isEnteredTeamExist = teams?.find(
    (team) => team?.name?.toLowerCase() === enteredTeam?.toLowerCase(),
  )
  return isEnteredTeamExist
}

export const getCoachingPlanObject = (data, status = null) => {
  // Format scheduling conditions from API format (ISO dates) to form format (MM/DD/YYYY)
  const formatSchedulingConditionsForForm = (conditions) => {
    if (!conditions || !Array.isArray(conditions)) {
      return []
    }
    return conditions.map((condition) => {
      const formatted = {
        sessionIndex: condition.sessionIndex,
        condition: condition.condition,
        primaryDate: condition.primaryDate
          ? moment(condition.primaryDate).format('MM/DD/YYYY')
          : '',
      }
      if (condition.secondaryDate) {
        formatted.secondaryDate = moment(condition.secondaryDate).format(
          'MM/DD/YYYY',
        )
      }
      return formatted
    })
  }

  return {
    sowStatus: status || data?.sow?.sowStatus,
    isPaymentRequired: data?.sow?.isPaymentRequired === true ? 'true' : 'false',
    paymentStatus: data?.sow?.paymentStatus,
    planName: data?.sow?.planName || '',
    cancelledOn: data?.sow?.cancelledOn || null,
    clientTimeZone: data?.sow?.timeZone,
    paymentCycle: data?.sow?.paymentCycle,
    upfrontFee: data?.sow?.upfrontFee || 0,
    invoiceEvery: data?.sow?.invoiceEvery,
    numberOfCoachingCycle: data?.sow?.numberOfCoachingCycle || '',
    numberOfBillingCycle: data?.sow?.numberOfBillingCycle || '',
    subscriptionAmount: data?.sow?.subscriptionAmount,
    onetimeAmount: data?.sow?.onetimeAmount || 0,
    totalDurationOfContract: data?.sow?.totalDurationOfContract,
    typeOfCoachingCycle: data?.sow?.typeOfCoachingCycle || 'Monthly',
    totalSession: data?.sow?.totalSession,
    sessionPerCoachingCycle: data?.sow?.sessionPerCoachingCycle,
    numberOfMonths: data?.sow?.numberOfMonths,
    sessionDuration: data?.sow?.sessionDuration,
    growthSessionDuration: data?.sow?.growthSessionDuration,
    coachingRate: data?.sow?.coachingRate,
    growthCoachingRate: data?.sow?.growthCoachingRate,
    growthCoachingRateType: data?.sow?.growthCoachingRateType || 'hourly',
    coachingRateType: data?.sow?.coachingRateType || 'hourly',
    planStartDate: moment(data?.sow?.planStartDate).format('MM/DD/YYYY'),
    terminatedOn: data?.sow?.terminatedOn,
    isOld: data?.sow?.isOld || false,
    setToBeTerminated: data?.sow?.setToBeTerminated || false,
    // SOW Type and Conditional Scheduling
    sowType: data?.sow?.sowType || 'REGULAR',
    isPlatformScheduling: data?.sow?.isPlatformScheduling,
    includeBioInMail: data?.sow?.includeBioInMail,
    questId: data?.sow?.questId || '',
    questName: data?.sow?.questName || data?.sow?.quest?.name || '',
    isConditionalSchedulingEnabled:
      data?.sow?.isConditionalSchedulingEnabled || false,
    schedulingConditions: formatSchedulingConditionsForForm(
      data?.sow?.schedulingConditions,
    ),
    // report360:
    //   data?.sow?.report360 === null || data?.sow?.report360 === undefined
    //     ? false
    //     : true,
    // reportPlan360:
    //   data?.sow?.report360 === null || data?.sow?.report360 === undefined
    //     ? ''
    //     : data?.sow?.report360,
    // impactReport:
    //   data?.sow?.impactReport === null || data?.sow?.impactReport === undefined
    //     ? false
    //     : true,
    // impactReportPlan:
    //   data?.sow?.impactReport === null || data?.sow?.impactReport === undefined
    //     ? ''
    //     : data?.sow?.impactReport,
    includeGrowthSession: data?.sow?.includeGrowthSession || false,
  }
}

const filterUniqueIds = (array) => {
  const result = array.reduce((prevIds, id) => {
    if (id) {
      return prevIds.includes(id) ? prevIds : [...prevIds, id]
    } else {
      return prevIds
    }
  }, [])
  return result
}

export const getUniqueAudioAndSkillIds = (audios, keySkills) => {
  if (!audios || !keySkills) {
    return {
      moduleIds: [],
      mediaIds: [],
      keySkillsIds: [],
    }
  }
  let wrapper = {}
  let modulesArr = audios?.values.filter((e) => 'parentId' in e)
  let mediasArr = audios?.values.filter((e) => !('parentId' in e))
  //module
  let moduleIds = modulesArr?.map((e) => e._id)
  const uniqueModuleIds = filterUniqueIds(moduleIds)
  wrapper.moduleIds = uniqueModuleIds
  //media
  let mediaIds = mediasArr?.map((e) => e._id)
  const uniqueMediaIds = filterUniqueIds(mediaIds)
  wrapper.mediaIds = uniqueMediaIds
  //key skills
  let keySkillsIds = keySkills?.values?.map((e) => e._id)
  const uniqueSkillsIds = filterUniqueIds(keySkillsIds)
  wrapper.keySkillsIds = uniqueSkillsIds

  return wrapper
}

export const getStatusDefaultFilterValue = () => {
  const anyOptionObj = labels.statusFilterOptions.find(
    (value) => value.key === labels.statusFilterOptionsType.ANY,
  )
  return anyOptionObj?.key
}

export function isNumber(num) {
  const n = parseInt(num)
  return typeof n === 'number' && !isNaN(n) && isFinite(n)
}

export const scrollAdminContentToTop = () => {
  const content = document.getElementById('content')
  if (content) {
    content.scrollTop = 0
  }

  const scrollableRow = document.querySelector(
    '.custom-container > .overflow-auto',
  )
  if (scrollableRow) {
    scrollableRow.scrollTop = 0
  }

  // Experience Build/Manage — only the right pane scrolls
  document
    .querySelectorAll('.experience-editor-main, .experience-overview')
    .forEach((el) => {
      el.scrollTop = 0
    })

  window.scrollTo(0, 0)
}

// Decodes HTML entities from sanitize-html plain-text output (e.g. &amp; -> &)
export const decodeHtmlEntities = (text = '') => {
  const textarea = document.createElement('textarea')
  textarea.innerHTML = text
  return textarea.value
}
